document.querySelectorAll('ul, ol').forEach(list => {
    list.querySelectorAll('li').forEach(item => {
        if (item.querySelector('strong')) {
            item.classList.add('bold-list');
        }
    });
});
